import Heading from "shared/ui/typography/Heading";

const CheckoutDoorListHeader = () => {
  return (
    <header className="gg-w-full lg:gg-grid gg-grid-cols-12 gg-uppercase gg-mb-3 gg-hidden">
      <Heading
        headingLevel="h6"
        className="gg-col-span-7 lg:gg-col-span-8 xl:gg-col-span-7 !gg-font-bold"
      >
        product
      </Heading>
      <Heading
        headingLevel="h6"
        className="gg-col-span-3 xl:gg-col-span-4 !gg-font-bold"
      >
        opties
      </Heading>
      <Heading
        headingLevel="h6"
        className="gg-col-span-1 xl:gg-col-span-1 !gg-font-bold"
      >
        prijs
      </Heading>
    </header>
  );
};
export default CheckoutDoorListHeader;
